module.exports = __webpack_public_path__ + "static/media/follower-analyzer-cover.dbbe3165.jpg";